'use client'

import { FC } from 'react'

const VideoCarouselOverlayStyles: FC = () => {
  return (
    <style>{`
      .carousel-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(30, 30, 30, 0.98);
        border-radius: 20px 20px 0 0;
        /* エンドスクリーン(.sp-end-screen, z-index:10000)より前面に出す。
           小さい値だと黒背景の裏に隠れて「別の動画へ」で何も出ない不具合になる。 */
        z-index: 10002;
        transform: translateY(100%);
        transition: transform 300ms cubic-bezier(0.32, 0.72, 0, 1);
        max-height: 70%;
        display: flex;
        flex-direction: column;
      }

      .carousel-overlay.visible {
        transform: translateY(0);
      }

      .carousel-close-button {
        width: 100%;
        padding: 6px;
        display: flex;
        justify-content: center;
        background: transparent;
        border: none;
        cursor: pointer;
        flex-shrink: 0;
      }

      .carousel-close-icon {
        width: 28px;
        height: 28px;
        transition: opacity 200ms ease;
      }

      .carousel-close-button:active .carousel-close-icon path {
        stroke: rgba(255, 255, 255, 1);
      }

      .carousel-scroll-container {
        flex: 1;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;
        padding: 0 16px 26px;
      }

      .carousel-scroll-container::-webkit-scrollbar {
        display: none;
      }

      .carousel-items {
        display: flex;
        gap: 14px;
        // padding-bottom: 8px;
      }

      .carousel-card {
        flex-shrink: 0;
        width: 130px;
        background: rgba(50, 50, 50, 0.8);
        border-radius: 16px;
        overflow: hidden;
        cursor: pointer;
        transition: transform 200ms ease, box-shadow 200ms ease;
      }

      .carousel-card:hover {
        transform: scale(1.02);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
      }

      .carousel-card:active {
        transform: scale(0.98);
      }

      .carousel-thumbnail {
        position: relative;
        width: 100%;
        aspect-ratio: 1 / 1;
        background: #222;
      }

      .carousel-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .carousel-thumbnail-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #333 0%, #222 100%);
      }

      .carousel-backdrop {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        /* エンドスクリーン(z-index:10000)より前面・カルーセル本体より背面に置く。 */
        z-index: 10001;
        opacity: 0;
        transition: opacity 300ms ease;
        pointer-events: none;
      }

      .carousel-backdrop.visible {
        opacity: 1;
      }
    `}</style>
  )
}

export default VideoCarouselOverlayStyles
